import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { Menu } from "../../../components/menu-consultas";

export const LayoutConsultaCivil: React.FC = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <MUI.Stack pt={[2, 0]} flexDirection="row" width="100%" height="80vh">
      <Menu
        titulo="Consulta civil"
        menu={[
          {
            to: "/consulta-civil-pesquisa-nominal",
            label: "Pesquisa nominal",
            icon: <Icon.PersonSearch sx={{ color: "white" }} />,
            isSelected: pathname === "/consulta-civil-pesquisa-nominal",
          },
          {
            to: "/consulta-civil-pesquisa-por-rg",
            label: "Pesquisa RG",
            icon: <Icon.PersonSearch sx={{ color: "white" }} />,
            isSelected: pathname === "/consulta-civil-pesquisa-por-rg",
          },
          {
            to: "/consulta-civil-pesquisa-por-cpf",
            label: "Pesquisa CPF",
            icon: <Icon.PersonSearch sx={{ color: "white" }} />,
            isSelected: pathname === "/consulta-civil-pesquisa-por-cpf",
          },
          {
            to: "/pagina-inicial",
            icon: <Icon.KeyboardReturn sx={{ color: "white" }} />,
            label: "Voltar página inicial",
          },
        ]}
      />
      <MUI.Stack flex={1} padding={2} gap={1} overflow="auto">
        {children}
      </MUI.Stack>
    </MUI.Stack>
  );
};
